import { generateKeys } from '../utils';
import { countries } from './countries';
const depositBanks = {
    aff: {
        country: countries.my.key,
        currency: 'MYR',
        value: 'AFF',
        label: 'Affin Bank',
    },
    mbb: { country: countries.my.key,
        currency: 'MYR',
        value: 'MBB',
        label: 'Maybank Berhad' },
    pbb: { country: countries.my.key,
        currency: 'MYR',
        value: 'PBB',
        label: 'Public Bank Berhad' },
    cimb: { country: countries.my.key,
        currency: 'MYR',
        value: 'CIMB',
        label: 'CIMB Bank Berhad' },
    hlb: { country: countries.my.key,
        currency: 'MYR',
        value: 'HLB',
        label: 'Hong Leong Bank Berhad' },
    rhb: { country: countries.my.key,
        currency: 'MYR',
        value: 'RHB',
        label: 'RHB Banking Group' },
    amb: { country: countries.my.key,
        currency: 'MYR',
        value: 'AMB',
        label: 'AmBank Group' },
    bimb: { country: countries.my.key,
        currency: 'MYR',
        value: 'BIMB',
        label: 'Bank Islam Malaysia' },
    kkr: { country: countries.th.key,
        currency: 'THB',
        value: 'KKR',
        label: 'Karsikorn Bank (K-Bank)' },
    bbl: { country: countries.th.key,
        currency: 'THB',
        value: 'BBL',
        label: 'Bangkok Bank' },
    scb: { country: countries.th.key,
        currency: 'THB',
        value: 'SCB',
        label: 'Siam Commercial Bank' },
    ktb: { country: countries.th.key,
        currency: 'THB',
        value: 'KTB',
        label: 'Krung Thai Bank' },
    boa: { country: countries.th.key,
        currency: 'THB',
        value: 'BOA',
        label: 'Bank of Ayudhya (Krungsri)' },
    gsb: { country: countries.th.key,
        currency: 'THB',
        value: 'GSB',
        label: 'Government Savings Bank' },
    tmb: { country: countries.th.key,
        currency: 'THB',
        value: 'TMB',
        label: 'Bank Public Company Limited' },
    knk: { country: countries.th.key,
        currency: 'THB',
        value: 'KNK',
        label: 'Kiatnakin Bank' },
    cimbt: {
        country: countries.th.key,
        currency: 'THB',
        value: 'CIMBT',
        label: 'CIMB Thai',
    },
    pptp: {
        country: countries.th.key,
        currency: 'THB',
        value: 'PPTP',
        label: 'Promptpay',
    },
    tcb: { country: countries.vn.key,
        currency: 'VND',
        value: 'TCB',
        label: 'Techcombank' },
    sacom: { country: countries.vn.key,
        currency: 'VND',
        value: 'SACOM',
        label: 'Sacombank' },
    vcb: { country: countries.vn.key,
        currency: 'VND',
        value: 'VCB',
        label: 'Vietcombank' },
    acb: { country: countries.vn.key,
        currency: 'VND',
        value: 'ACB',
        label: 'Asia Commercial Bank' },
    dab: { country: countries.vn.key,
        currency: 'VND',
        value: 'DAB',
        label: 'DongA Bank' },
    vtb: { country: countries.vn.key,
        currency: 'VND',
        value: 'VTB',
        label: 'Vietinbank' },
    bidv: { country: countries.vn.key,
        currency: 'VND',
        value: 'BIDV',
        label: 'Bank for Investment and Development of Vietnam' },
    exim: { country: countries.vn.key,
        currency: 'VND',
        value: 'EXIM',
        label: 'Eximbank Vietnam' },
    mb: {
        value: 'MB',
        label: 'Military Commercial Joint Stock Bank',
        country: countries.vn.key,
        currency: 'VND',
    },
    scmb: {
        value: 'SCMB',
        label: 'SAIGON Bank',
        country: countries.vn.key,
        currency: 'VND',
    },
    mtmb: {
        value: 'MTMB',
        label: 'Maritime Bank',
        country: countries.vn.key,
        currency: 'VND',
    },
    tpb: {
        value: 'TPB',
        label: 'Tien Phong Bank',
        country: countries.vn.key,
        currency: 'VND',
    },
    vpb: {
        value: 'VPB',
        label: 'VP Bank',
        country: countries.vn.key,
        currency: 'VND',
    },
    vib: {
        value: 'VIB',
        label: 'Vietnam International Bank',
        country: countries.vn.key,
        currency: 'VND',
    },
    bca: { country: countries.id.key,
        currency: 'IDR',
        value: 'BCA',
        label: 'Bank Central Asia' },
    bni: { country: countries.id.key,
        currency: 'IDR',
        value: 'BNI',
        label: 'Bank Negara Indonesia' },
    bri: { country: countries.id.key,
        currency: 'IDR',
        value: 'BRI',
        label: 'Bank Rakyat Indonesia' },
    mdr: { country: countries.id.key,
        currency: 'IDR',
        value: 'MDR',
        label: 'Mandiri Bank' },
    cimbn: { country: countries.id.key,
        currency: 'IDR',
        value: 'CIMBN',
        label: 'CIMB Niaga' },
    bdo: {
        value: 'BDO',
        label: 'Banco de Oro',
        country: countries.ph.key,
        currency: 'PHP',
    },
    mtb: {
        value: 'MTB',
        label: 'MetroBank',
        country: countries.ph.key,
        currency: 'PHP',
    },
    bpi: {
        value: 'BPI',
        label: 'Bank of the Philippine Islands',
        country: countries.ph.key,
        currency: 'PHP',
    },
    lbp: {
        value: 'LBP',
        label: 'Land Bank of the Philippines',
        country: countries.ph.key,
        currency: 'PHP',
    },
    pnb: {
        value: 'PNB',
        label: 'Philippine National Bank',
        country: countries.ph.key,
        currency: 'PHP',
    },
    rcbc: {
        value: 'RCBC',
        label: 'Rizal Commercial Banking Corporation',
        country: countries.ph.key,
        currency: 'PHP',
    },
    axis: { value: 'AXIS', label: 'AXIS Bank', country: countries.in.key, currency: 'INR' },
    hdfc: { value: 'HDFC', label: 'HDFC Bank', country: countries.in.key, currency: 'INR' },
    idfc: { value: 'IDFC', label: 'IDFC Bank', country: countries.in.key, currency: 'INR' },
    indusind: { value: 'INDUSIND', label: 'INDUSIND Bank', country: countries.in.key, currency: 'INR' },
    kotak: { value: 'KOTAK', label: 'KOTAK Mahindra Bank', country: countries.in.key, currency: 'INR' },
};
export const help2payDepositBanks = generateKeys(depositBanks);
const withdrawalBanks = {
    aff: { value: 'AFF', label: 'Affin Bank', country: countries.my.key, currency: 'MYR' },
    alb: { value: 'ALB', label: 'Alliance Bank', country: countries.my.key, currency: 'MYR' },
    amb: { value: 'AMB', label: 'AM Bank', country: countries.my.key, currency: 'MYR' },
    bsn: { value: 'BSN', label: 'Bank Simpanan National', country: countries.my.key, currency: 'MYR' },
    cimb: { value: 'CIMB', label: 'CIMB Bank', country: countries.my.key, currency: 'MYR' },
    citi: { value: 'CITI', label: 'Citi bank', country: countries.my.key, currency: 'MYR' },
    hlb: { value: 'HLB', label: 'Hong Leong Bank', country: countries.my.key, currency: 'MYR' },
    hsbc: { value: 'HSBC', label: 'HSBC Bank', country: countries.my.key, currency: 'MYR' },
    mbb: { value: 'MBB', label: 'Maybank', country: countries.my.key, currency: 'MYR' },
    ocbc: { value: 'OCBC', label: 'OCBC Bank', country: countries.my.key, currency: 'MYR' },
    pbb: { value: 'PBB', label: 'Public Bank', country: countries.my.key, currency: 'MYR' },
    rhb: { value: 'RHB', label: 'RHB Bank', country: countries.my.key, currency: 'MYR' },
    uob: { value: 'UOB', label: 'UOB Bank', country: countries.my.key, currency: 'MYR' },
    sctb: { value: 'SCTB', label: 'Standard Chartered Bank', country: countries.my.key, currency: 'MYR' },
    bimb: { value: 'BIMB', label: 'Bank Islam Malaysia', country: countries.my.key, currency: 'MYR' },
    bbl: { value: 'BBL', label: 'Bangkok Bank', country: countries.th.key, currency: 'THB' },
    boa: { value: 'BOA', label: 'Bank Of Ayudhya', country: countries.th.key, currency: 'THB' },
    gsb: { value: 'GSB', label: 'Government Savings Bank', country: countries.th.key, currency: 'THB' },
    kkr: { value: 'KKR', label: 'KasiKorn Bank', country: countries.th.key, currency: 'THB' },
    ktb: { value: 'KTB', label: 'KTB Net Bank', country: countries.th.key, currency: 'THB' },
    scb: { value: 'SCB', label: 'Siam Commercial Bank', country: countries.th.key, currency: 'THB' },
    tmb: { value: 'TMB', label: 'TMB Bank Public Company Limited', country: countries.th.key, currency: 'THB' },
    cimbt: { value: 'CIMBT', label: 'CIMB Thai', country: countries.th.key, currency: 'THB' },
    knk: { value: 'KNK', label: 'Kiatnakin Bank', country: countries.th.key, currency: 'THB' },
    pptp: { value: 'PPTP', label: 'Promptpay', country: countries.th.key, currency: 'THB' },
    acb: { value: 'ACB', label: 'Asia Commercial Bank', country: countries.vn.key, currency: 'VND' },
    dab: { value: 'DAB', label: 'DongA Joint Stock Commercial Bank', country: countries.vn.key, currency: 'VND' },
    sacom: { value: 'SACOM', label: 'Sacom Bank', country: countries.vn.key, currency: 'VND' },
    tcb: { value: 'TCB', label: 'Techcom Bank', country: countries.vn.key, currency: 'VND' },
    vcb: { value: 'VCB', label: 'Vietcom Bank', country: countries.vn.key, currency: 'VND' },
    vtb: { value: 'VTB', label: 'Vietin Bank', country: countries.vn.key, currency: 'VND' },
    exim: { value: 'EXIM', label: 'Eximbank Vietnam', country: countries.vn.key, currency: 'VND' },
    bidv: { value: 'BIDV', label: 'Bank for Investment and Development of Vietnam', country: countries.vn.key, currency: 'VND' },
    scmb: { value: 'SCMB', label: 'SAIGON Bank', country: countries.vn.key, currency: 'VND' },
    vib: { value: 'VIB', label: 'Vietnam International Bank', country: countries.vn.key, currency: 'VND' },
    agb: { value: 'AGB', label: 'Agribank', country: countries.vn.key, currency: 'VND' },
    mb: { value: 'MB', label: 'Military Commercial Joint Stock Bank', country: countries.vn.key, currency: 'VND' },
    mtmb: { value: 'MB', label: 'Military Commercial Joint Stock Bank', country: countries.vn.key, currency: 'VND' },
    tpb: { value: 'TPB', label: 'Tien Phong Bank', country: countries.vn.key, currency: 'VND' },
    vpb: { value: 'VPB', label: 'VP Bank', country: countries.vn.key, currency: 'VND' },
    bca: { value: 'BCA', label: 'Bank Central Asia', country: countries.id.key, currency: 'IDR' },
    bni: { value: 'BNI', label: 'Bank Negara Indonesia', country: countries.id.key, currency: 'IDR' },
    mdr: { value: 'MDR', label: 'Bank Mandiri', country: countries.id.key, currency: 'IDR' },
    bri: { value: 'BRI', label: 'Bank Rakyat Indonesia', country: countries.id.key, currency: 'IDR' },
    cimbn: { value: 'CIMBN', label: 'CIMB Niaga', country: countries.id.key, currency: 'IDR' },
    bdo: { value: 'BDO', label: 'Banco de Oro', country: countries.ph.key, currency: 'PHP' },
    bdoe: { value: 'BDOe', label: 'Banco de Oro Corporate Account', country: countries.ph.key, currency: 'PHP' },
    mtb: { value: 'MTB', label: 'MetroBank', country: countries.ph.key, currency: 'PHP' },
    bpi: { value: 'BPI', label: 'Bank of the Philippine Islands', country: countries.ph.key, currency: 'PHP' },
    lbp: { value: 'LBP', label: 'Land Bank of the Philippines', country: countries.ph.key, currency: 'PHP' },
    pnb: { value: 'PNB', label: 'Philippine National Bank', country: countries.ph.key, currency: 'PHP' },
    rcbc: { value: 'RCBC', label: 'Rizal Commercial Banking Corporation', country: countries.ph.key, currency: 'PHP' },
};
export const help2payWithdrawalBanks = generateKeys(withdrawalBanks);
